/* * @Author: 曹俊杰 * @Date: 2024-09-22 14:56:53 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-05-06 21:57:12 */代金券
<template>
  <div class="box">
    <topsearch
      :searchForm.sync="listParams"
      @submit="getList"
      @onClear="onClear"
      @tabsClick="tabsClick"
    />
    <div class="content">
      <div class="title">代金劵列表</div>
      <el-table
        :data="list"
        style="width: 100%"
        row-class-name="defTableRowStyle"
        header-row-class-name="defTableHeaderStyle"
      >
        <el-table-column label="代金劵金额">
          <template slot-scope="scope">
            <span v-html="voucherAmountRender(scope.row)"></span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="数量">
          <template slot-scope="scope">
            <span>x{{ scope.row.count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <div v-html="voucherTypeRender(scope.row)"></div>
          </template>
        </el-table-column>

        <el-table-column prop="rewardBalance" label="有效时间">
          <template slot-scope="scope">
            <div style="color: #666666; font-size: 12px">
              <div>起：{{ scope.row.validFrom | timeFormat("yyyy-mm-dd hh:MM:ss") }}</div>
              <div>
                止：{{ scope.row.validUntil | timeFormat("yyyy-mm-dd hh:MM:ss") }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="rewardBalance" label="来源">
          <template slot-scope="scope">
            <span>{{ EnumRender(scope.row.source, voucherSourceData) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rewardBalance" label="状态">
          <template slot-scope="scope">
            <div v-html="voucherStateDataRender(scope.row)"></div>
          </template>
        </el-table-column>
        <template slot="empty">
          <empty />
        </template>
        <el-table-column prop="rewardBalance" label="操作">
          <template slot-scope="scope">
            <span
              @click="give(scope.row)"
              class="primary pointer"
              v-if="scope.row.state === 0"
              >赠送</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <hdqPagination
          layout="prev, pager, next,sizes"
          ref="pagination"
          @change="getList"
        />
      </div>
    </div>
    <givePopup ref="givePopupRef" @success="getList" />
  </div>
</template>

<script>
import topsearch from "./Voucher/topsearch.vue";
import hdqPagination from "@/components/hdqPagination.vue";
import selectData from "@/mixins/selectData.js";
import givePopup from "./components/givePopup.vue";
const listParams = {
  source: null,
  state: "0", //合同状态
  type: null, //合同保障状态
  validUntilStart: null, //起始时间
  validUntilEnd: null, //结束时间
};
export default {
  mixins: [selectData],
  components: {
    topsearch,
    hdqPagination,
    givePopup,
  },
  data() {
    return {
      active: "0",
      list: [],
      listParams: {
        ...listParams,
      },
    };
  },
  mounted() {
    this.getList();
  },
  computed: {},
  methods: {
    give(row) {
      this.$refs.givePopupRef.onshow(row);
    },
    tabsClick() {
      setTimeout(() => {
        this.getList();
      }, 300);
    },
    onClear() {
      this.listParams = { ...listParams };
    },
    // typeRender(data) {
    //   const item = this.voucherTypeData.find((res) => res.value == data.type);
    //   let style = "";
    //   if (item.value === 1) {
    //     style =
    //       "background: linear-gradient(90deg, #BC6416 3%, #914F1A 100%);background-clip: text;text-fill-color: transparent;";
    //   }
    //   if (item.value === 2) {
    //     style = "color: #0062FF;";
    //   }
    //   return `<span style="${style}">${item.label}</span>`;
    // },

    async getList() {
      const { current, size } = this.$refs.pagination;
      const { params } = this.$route;
      let { listParams } = this;
      let time = {
        initiatedAtFrom: null,
        initiatedAtTo: null,
      };
      if (listParams.initiated) {
        const [star, end] = listParams.initiated;
        time.initiatedAtFrom = star;
        time.initiatedAtTo = end;
        let { obj, ...initiated } = listParams;
        listParams = obj;
      }
      const { status, data } = await this.$api.getVoucherGroupList({
        current,
        size,
        ...listParams,
        ...params,
        ...time,
      });
      if (status == 200) {
        this.list = data.records;
        this.$refs.pagination.createPagination(data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  flex-direction: column;

  .content {
    padding: 0 20px;
    margin-top: 16px;
    background: #fff;
    border-radius: 6px;

    .title {
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 60px;
    }
  }
  .pagination {
    @include paginationStyle;
  }
}
</style>
